<td
    nz-popover
    [nzPopoverContent]="productPopover"
    [class.hidden]="!isColumnVisible('orderId')"
>
    <div class="flex flex-col items-center">
        <div class="flex items-center gap-1">
            <a (click)="openDetails(order)"> #{{ order.id }} </a>
            <i
                *ngIf="
                    order?.extras?.needsMedicalTeamContact === 'true' ||
                    order?.extras?.needsMedicalTeamContact === true
                "
                class="fa-solid fa-exclamation-circle text-amber-600 text-xs"
                nz-tooltip
                nzTooltipTitle="Medical Team Contact Required"
            ></i>
        </div>
        <span class="text-xs text-gray-500">{{ orderSource }}</span>
    </div>
</td>
<td [class.hidden]="!isColumnVisible('customer')">
    <a
        *ngIf="customer"
        [href]="
            customer._id ? getCustomerUrl(customer._id) : 'javascript:void(0)'
        "
        >{{ customer.firstName + ' ' + customer.lastName | titlecase }}</a
    >
</td>
<td [class.hidden]="!isColumnVisible('createdDate')">
    {{ order.createdAt | date : _getDateFormat(order.createdAt) }}
</td>
<td [class.hidden]="!isColumnVisible('lastUpdate')">
    {{ lastUpdateDate }}
</td>

<td [class.hidden]="!isColumnVisible('price')">
    {{ toDollars(order.totalAmount) }}
</td>
<td [class.hidden]="!isColumnVisible('status')" style="min-width: 220px">
    <nz-select
        [ngModel]="order.status"
        (ngModelChange)="changeStatus($event, order)"
        class="w-full"
    >
        <nz-option
            *ngFor="let status of statuses"
            [nzValue]="status[0]"
            [nzLabel]="status[1].name"
        ></nz-option>
    </nz-select>
</td>
<td [class.hidden]="!isColumnVisible('paymentStatus')">
    <div
        *ngIf="paymentStatusInfo"
        class="flex items-center space-x-2 bg-gray-50 rounded-md px-3 py-1 w-fit"
        [nzTooltipTitle]="order?.payment?.failedReason"
        nz-tooltip
    >
        <i
            [class]="paymentStatusInfo.icon"
            [style.color]="paymentStatusColor"
            class="text-sm"
        ></i>
        <span [style.color]="paymentStatusColor" class="text-sm font-medium">
            {{ paymentStatusInfo.name }}
        </span>
    </div>
</td>
<td [class.hidden]="!isColumnVisible('state')">
    {{ order.shippingAddress?.provinceCode || order.shippingAddress?.province }}
</td>
<td [class.hidden]="!isColumnVisible('assignedTo')">
    <ng-container *ngIf="order.assignedToGroup">
        <nz-tag nzColor="cyan"> {{ order.assignedToGroup }}</nz-tag>
    </ng-container>
    <ng-container *ngIf="assignedToLabel">
        <nz-tag>
            {{ assignedToLabel }}
        </nz-tag>
    </ng-container>
</td>
<td [class.hidden]="!isColumnVisible('assignedPharmacy')">
    <ng-container *ngIf="assignedPharmacyLabel">
        <nz-tag nzColor="blue">
            {{ assignedPharmacyLabel }}
        </nz-tag>
    </ng-container>
</td>
<td [class.hidden]="!isColumnVisible('actions')" style="text-align: right">
    <ng-container
        *ngIf="
            order?.payment?.status === 'failed' ||
            order?.payment?.status === 'delayed_capture' ||
            order?.payment?.status === 'partial_paid' ||
            order?.payment?.status === 'pending' ||
            order?.payment?.status === 'voided' ||
            (!order?.payment &&
                ['pending', 'awaiting_payment'].includes(order.status))
        "
    >
        <button
            nz-button
            nzShape="round"
            nzSize="default"
            nzType="link"
            [nzLoading]="isLoading"
            (click)="chargeOrder(order)"
        >
            Charge
        </button>

        <nz-divider nzType="vertical"></nz-divider>
    </ng-container>

    <button
        nz-button
        nzShape="circle"
        nzSize="default"
        nzType="link"
        (click)="openDetails(order)"
    >
        <i class="fa-solid fa-eye"></i>
    </button>

    <!-- <i
                    *nzSpaceItem
                    nz-icon
                    nzType="reload"
                    nzTheme="outline"
                ></i> -->
</td>

<ng-template #productPopover
    ><portals-emr-order-products-popover
        [items]="order.lineItems"
    ></portals-emr-order-products-popover
></ng-template>
